import { createGoldMaterial } from 'heritage/gold-material.js';
import { createLaurelRelief } from 'heritage/laurel-relief.js';

const ease=(a,b,x)=>{const t=Math.max(0,Math.min(1,(x-a)/(b-a)));return t*t*(3-2*t);};
export function sampleSymbolFinishes(progress){
  return {
    diamond:ease(.26,.325,progress)*(1-ease(.425,.49,progress)),
    // Stay fully gold while Achievement is on screen. Return to black only
    // after that caption clears, before the combined Imperial Bee appears.
    gold:ease(.49,.51,progress)*(1-ease(.73,.75,progress))
  };
}

export function createLaurelMaterial(shape){
  const finish={value:0};
  const relief=createLaurelRelief(shape);
  const material=createGoldMaterial({normalMap:relief,clearcoatNormalMap:relief,depthWrite:true,forceSinglePass:true});
  // A single surface changes finish. Mixing after display conversion makes
  // the inactive emblem the same exact black as the rest of the identity.
  material.userData.finish=finish;
  material.onBeforeCompile=shader=>{
    shader.uniforms.uLaurelFinish=finish;
    shader.fragmentShader=shader.fragmentShader.replace('#include <common>','#include <common>\nuniform float uLaurelFinish;\n')
      .replace('#include <colorspace_fragment>','#include <colorspace_fragment>\ngl_FragColor.rgb=mix(vec3(8.0/255.0),gl_FragColor.rgb,uLaurelFinish);');
  };
  material.customProgramCacheKey=()=> 'ring-gold-laurel-43';
  return material;
}